import ReceberService from "@/services/ReceberService";

export const receber = {
  namespaced: true,
  state: {
    receber: {},
  },
  actions: {
    getReceber({ commit }, payload) {
      return ReceberService.GetReceber(payload).then(
        (receber) => {
          return Promise.resolve(receber);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postReceber({ commit }, payload) {
      return ReceberService.PostReceber(payload).then(
        (receber) => {
          return Promise.resolve(receber);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putReceber({ commit }, payload) {
      return ReceberService.PutReceber(payload).then(
        (receber) => {
          return Promise.resolve(receber);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteReceber({ commit }, payload) {
      return ReceberService.DeleteReceber(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getReceberOData({ commit }, payload) {
      return ReceberService.GetReceberOData(payload).then(
        (receber) => {
          return Promise.resolve(receber);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    estornar({ commit }, payload) {
      return ReceberService.Estornar(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    receberRegistros({ commit }, payload) {
      return ReceberService.ReceberRegistros(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    replicarRegistros({ commit }, payload) {
      return ReceberService.ReplicarRegistros(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    renegociarRegistros({ commit }, payload) {
      return ReceberService.RenegociarRegistros(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    imprimirRecibo({ commit }, payload) {
      return ReceberService.ImprimirRecibo(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRelatorio({ commit }, payload) {
      return ReceberService.GetRelatorio(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default receber;
